<button type="button" class="btn btn-disable" (click)="downloadTemplate()">
  <i class="bi bi-download" aria-hidden="true"></i> {{ 'DOWNLOAD_TEMPLATE' | translate }}
</button>

<button type="button" class="btn btn-disable" (click)="openModal()">
  <i class="bi bi-upload" aria-hidden="true"></i> {{ 'UPLOAD_TEMPLATE' | translate }}
</button>

<!-- Bootstrap 5 Modal -->
<div class="modal fade" tabindex="-1" style="background: rgba(0,0,0,0.5);" id="bulkAccountAccessModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Procesamiento Masivo de Acceso</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        
        <!-- Acción a realizar -->
        <!-- <div class="mb-3">
          <label class="form-label fw-bold">Acción a realizar:</label>
          <select class="form-select" [(ngModel)]="selectedAction">
            <option value="disable">Desactivar Acceso</option>
            <option value="enable">Activar Acceso</option>
          </select>
        </div> -->

        <!-- Carga de Archivo -->
        <div class="mb-3">
          <label class="form-label">Subir archivo Excel:</label>
          <input type="file" class="form-control" accept=".xlsx, .xls" (change)="onFileSelected($event)">
        </div>

        <!-- Loading Preview -->
        <div *ngIf="isLoadingPreview" class="text-center my-4">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2">Validando clientes en base de datos...</p>
        </div>

        <!-- Vista Previa y Resultados -->
        <div *ngIf="!isLoadingPreview && file">
          <div class="alert alert-info d-flex justify-content-between align-items-center">
            <span>
              <strong>Total en Excel:</strong> {{ validClients.length + errorClients.length }} | 
              <strong>Listos para procesar:</strong> {{ validClients.length }} | 
              <strong>Con errores:</strong> {{ errorClients.length }}
            </span>
            <button class="btn btn-sm btn-warning" *ngIf="errorClients.length > 0" (click)="downloadErrorReport()">
              Descargar Reporte de Errores
            </button>
          </div>

          <!-- Tabla de Clientes Válidos -->
          <div *ngIf="validClients.length > 0" class="table-responsive" style="max-height: 300px; overflow-y: auto;">
            <table class="table table-sm table-striped">
              <thead class="table-light sticky-top">
                <tr>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Cédula</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of validClients">
                  <td>{{ client.firstName }}</td>
                  <td>{{ client.lastName }}</td>
                  <td>{{ client.nationalId }}</td>
                  <td>{{ client.email }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="validClients.length === 0 && errorClients.length > 0" class="alert alert-warning">
            Ningún cliente válido para procesar. Revise el reporte de errores.
          </div>
        </div>

      </div>
      <!-- Barra de Progreso Estimada (Solo visible durante el procesamiento) -->
      <div *ngIf="isProcessing" class="mt-4 p-3 bg-light rounded border">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="fw-semibold text-primary">
            <i class="bi bi-hourglass-split me-1"></i>
            Procesando en segundo plano...
          </span>
          <span class="badge bg-primary">{{ progress | number:'1.0-0' }}%</span>
        </div>
        
        <div class="progress" style="height: 24px;">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
            role="progressbar" 
            [style.width.%]="progress"
            [attr.aria-valuenow]="progress" 
            aria-valuemin="0" 
            aria-valuemax="100">
            <span *ngIf="progress > 15" class="fw-bold text-white">
              {{ progress < 99 ? 'Procesando...' : 'Finalizando...' }}
            </span>
          </div>
        </div>
        
        <p class="text-muted small mt-2 mb-0 text-center">
          Se están procesando {{ validClients.length }} clientes. 
          Puedes cerrar esta ventana, el proceso continuará en el servidor.
        </p>
      </div>

      <!-- Botón de acción (Deshabilitado mientras procesa) -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isProcessing">
          Cancelar
        </button>
        <button type="button" class="btn btn-success" 
                [disabled]="validClients.length === 0 || isProcessing" 
                (click)="processBulk()">
          <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-1"></span>
          {{ isProcessing ? 'Iniciando...' : 'Confirmar y Procesar' }}
        </button>
      </div>
    </div>
  </div>
</div>